import { z } from 'zod'
import { paginationSchema } from './pagination'

export const searchSubmissionSchema = z.object({
  pagination: paginationSchema,
  results: z.array(
    z
      .object({
        id: z.string(),
        user: z.string().nullable(),
        search: z.string().nullable(),
        created_at: z.string(),
      })
      .transform((data) => {
        const { created_at, ...rest } = data
        return {
          ...rest,
          createdAt: created_at,
        }
      })
  ),
})
